export function formatNewChatTitle(): string {
  const now = new Date();  const time = now.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit',
    second: '2-digit',
    hour12: true 
  });
  const date = now.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric'
  });
  return `Chat ${date} ${time}`;
}
